import React from "react";
import { Button, Typography, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

import { AppPathNames } from "@/constants/AppPathNames";

import { ContentOnly as Layout } from "../../components/Layout";

import "./PageNotFound.scss";

const { Title, Text } = Typography;

const PageNotFound = () => {
  const navigate = useNavigate();

  const GoBack = () => {
    navigate(AppPathNames.root);
  };

  return (
    <Layout>
      <Row align="middle" justify="center">
        <Col>
          <div>
            <div className="page-not-found">
              <Title level={1} className="page-not-found__header">
                404
              </Title>
              <Title level={1} className="page-not-found__sub-header">
                Page not found
              </Title>
              <Text className="page-not-found__body">
                The page you have requested dosen't exist or an error occured! head back to{" "}
                <Text className="page-not-found__body--primary">Averroes.AI</Text>
              </Text>
              <Button className="page-not-found__btn" type="primary" onClick={GoBack}>
                Go back
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default PageNotFound;
